import { SerializableObject } from '../../common-react/core';

import { ResourceType } from '../other/search-resource-type.enum';

import { SearchResult } from './search-result.do';

export class SearchResultSet extends SerializableObject {
    resourceType: ResourceType;
    totalResults: number;
    returnedResults: number;
    results: SearchResult[];
}
